import Fetch from 'jsx/common/util/_fetch';

export const all = async () => {
  return Fetch.get(`/api/group/`);
};
